import React, { useContext } from 'react';
import { find, get, set } from 'lodash';

import FieldContainer from 'src/presentation/components/forms/FieldContainer';
import FormContext from 'src/presentation/contexts/FormContext';
import { MultiSelectDropdownMenu } from 'src/presentation/components/agent_desktop_components';

type MultiSelectDropdown = {
  attr: string;
  customTextFn?: (selected, placeholder) => void;
  'data-aid'?: string;
  description: string;
  label?: string;
  className?: string;
  tooltip?: string;
  onSelect?: (value) => void;
  options: { label: string; value: string }[];
};

export default function MultiSelectDropdown({
  attr,
  'data-aid': dataAid,
  description,
  label,
  className,
  options,
  tooltip,
  onSelect,
  customTextFn,
  ...otherProps
}: MultiSelectDropdown): JSX.Element {
  const { errors, workingState, updateState, resetError } = useContext(FormContext);
  const error = find(errors, error => error.attr === attr);

  const handleSelect = value => {
    resetError({ attr, errors });
    if (onSelect) {
      onSelect(value);
      return;
    }

    updateState(set({}, attr, value));
  };

  const values = get(workingState, attr, '');

  return (
    <FieldContainer
      className={error ? `${className} invalid` : className}
      description={description}
      error={get(error, 'detail')}
      label={label}
      preventContentFromOverflow // prevents a dropdown with long value to overflow its container
      control={
        <MultiSelectDropdownMenu
          className={className}
          data-aid={dataAid}
          onSelect={handleSelect}
          options={options}
          values={values}
          isError={!!error}
          tooltip={tooltip}
          customTextFn={customTextFn}
          {...otherProps}
        />
      }
    />
  );
}
